import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core'
import { Observable, Subscription } from 'rxjs'

import { Enums } from '@cyborg-monorepo/hunter/common'

import { tagDisplayName } from '../../../../helpers/display-names'
import {
  SearchStateService,
  Tag,
  TagType,
} from '../../../research/services/search-state.service'

@Component({
  standalone: false,
  selector: 'cyborg-filter',
  styleUrls: ['./cyborg-filter.component.scss'],
  templateUrl: './cyborg-filter.component.html',
})
export class CyborgFilterComponent implements OnInit, OnDestroy {
  private searchStateService = inject(SearchStateService)

  // Child select checkboxes values
  @Input() public filterData: TagType
  // Fires when input filter text is modified
  @Input('events') public filterText$?: Observable<string>

  public filterType: string

  public name: string
  public count = 0
  public tags: Tag[]
  public filteredTags: Tag[]

  private eventsSubscription?: Subscription

  public ngOnInit(): void {
    this.filterType = this.filterData.type
    this.name = tagDisplayName(this.filterData.type)
    this.tags = this.filterData.tags
    this.filteredTags = this.tags
    this.count = this.filteredTags.length

    if (this.filterText$) {
      this.eventsSubscription = this.filterText$.subscribe((filterText) => {
        this.onFilter(filterText)
      })
    }
  }

  public ngOnDestroy(): void {
    if (this.eventsSubscription) {
      this.eventsSubscription.unsubscribe()
    }
  }

  public onOpen(target: EventTarget): void {
    ;(target as HTMLElement).parentElement.classList.toggle('is-showing')
  }

  public onSelect(filterValue: string): void {
    if (
      this.filterType == Enums.Goals.HUNT ||
      this.filterType == Enums.Goals.DETECTION
    ) {
      const filterCurrentlySelected = this.isChecked(
        Enums.CyborgTagTypeEnum.GOALS,
        filterValue,
      )
      if (filterCurrentlySelected) {
        this.searchStateService.deleteFilter(
          Enums.CyborgTagTypeEnum.GOALS,
          filterValue,
        )
      } else {
        this.searchStateService.addFilter(
          Enums.CyborgTagTypeEnum.GOALS,
          filterValue,
        )
      }
    } else {
      const filterCurrentlySelected = this.isChecked(
        this.filterType,
        filterValue,
      )
      if (filterCurrentlySelected) {
        this.searchStateService.deleteFilter(this.filterType, filterValue)
      } else {
        this.searchStateService.addFilter(this.filterType, filterValue)
      }
    }
  }

  private onFilter(filterTextPattern: string): void {
    this.filteredTags = this.tags.filter((tag) => {
      return tag.key
        .toLowerCase()
        .includes(filterTextPattern.trim().toLowerCase())
    })
    this.count = this.filteredTags.length
  }

  /**
   * Return boolean if provided filter should be considered checked
   */
  public isChecked(filterType: string, filterValue: string): boolean {
    if (filterType == Enums.Goals.HUNT || filterType == Enums.Goals.DETECTION) {
      filterType = Enums.CyborgTagTypeEnum.GOALS
    }
    return this.searchStateService.isFilterActive(filterType, filterValue)
  }
}
